import InstagramThumbnail from './InstagramThumbnail'

export default InstagramThumbnail
